// Libraries
import React from "react";
import { connect } from 'react-redux';

// Local Libraries
import { gisRoutes } from "../../../../routes/routes";
import phrasebookLoad from "../../../../i18n";
import { capitalizeFirstLetter } from "../../../../helpers/util"
import * as token from '../../../../helpers/token';
import { accountTypesConstants } from '../../../../constants';
import { userStorage } from '../../../../helpers/user-storage';

// Redux
import { accountActions } from 'actions';
import { formConst } from '../../../../constants';


// Components
import { NewBreadcrumbs } from "../../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SubmitButton, CancelButton } from "../../../../components/SkyFramework/Buttons";
import { Form } from "../../../../components/SkyFramework/Forms";

// Constants
const phrasebook = phrasebookLoad()

class AccountAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      account_types: token.loggedAccountType() >= 200 ? accountTypesConstants.ACCOUNT_CUSTOMER_ADD : accountTypesConstants.ACCOUNT_ADD_PCCW,
      account_type_id: undefined,
      username: undefined,
      email: undefined,
      customer_id: token.loggedProperty('customer_id'),

      status_list: [{ value: 'requested', label: phrasebook.status.requested }, { value: 'created', label: phrasebook.status.created }, { value: 'active', label: phrasebook.status.active }, { value: 'terminated', label: phrasebook.status.terminated }],
      status: undefined,
      disabled_list: [{ value: true, label: phrasebook.common.true }, { value: false, label: phrasebook.common.false }],
      disabled: undefined,

      submitted: false
    }
    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    // if (token.loggedAccountType() >= 200)
    //   this.props.dispatch(accountActions.getAllCustomerAccountTypes(0, this.state.page));
    // else
    //   this.props.dispatch(accountActions.getAllAccountTypes(0, this.state.page, { pccwglobal_account_type: true }));
  }

  componentDidUpdate(prevProps) {
    if (this.props.account_types && prevProps && prevProps.account_types !== this.props.account_types) {
      this.setState({ account_types: this.props.account_types });
    }

  }

  handleChange(e) {
    const { id, name, value } = e.target;
    if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    var newValues = {
      username: this.state.username,
      email: this.state.email,
      account_type_id: this.state.account_type_id,
      customer_id: this.state.customer_id
    }
    if (token.loggedAccountType() >= 200)
      this.props.dispatch(accountActions.addCustomerAccount(newValues));
    else
      this.props.dispatch(accountActions.addInterimAccount(newValues));
  }

  FormProfile = () => {

    var accountOptions;
    if (token.loggedAccountType() == 100) accountOptions = formConst.accounttypes.admin;
    else if ([110, 120, 130, 140].includes(token.loggedAccountType())) accountOptions = formConst.accounttypes.pccwglobal_sub;
    else if ([200, 210, 220, 230, 240].includes(token.loggedAccountType())) accountOptions = formConst.accounttypes.master;
    const inputs = [
      { label: phrasebook.profile.account_type, type: "select", id: "account_type_id", name: "account_type_id", options: accountOptions, selected: this.state.account_type_id, empty_option: true },
      // { label: phrasebook.profile.username, type: "text", placeholder: this.state.username, id: "username", name: "username", value: this.state.username, required: true },
      { label: phrasebook.profile.email, type: "text", placeholder: this.state.email, id: "email", name: "email", value: this.state.email, required: true },
    ]
    const buttons = [<CancelButton title={phrasebook.common.back} link={gisRoutes.account.account.list} />, <SubmitButton title={phrasebook.common.add} />]
    return (
      <Form
        handleSubmit={this.handleSubmit}
        onChange={this.handleChange}
        title={phrasebook.profile.add_account}
        inputs={inputs}
        buttons={buttons}
      />)

  }

  render() {
    return <>
      <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }, { link: gisRoutes.account.account.list, label: phrasebook.headerlinks.accounts }]} current={phrasebook.headerlinks.accounts} />
      {this.FormProfile()}
    </>
  }
}

function mapStateToProps(state) {
  const { account, customer, authentication, georesource } = state;
  const { authUser } = authentication;
  return {
    authUser,
    customers: customer.customers,
    account_types: account.account_types,
    currencies: georesource.currencies,
    account: account.account
  };
}


const userAdd = connect(mapStateToProps)(AccountAdd);
export default (userAdd);
